import React from 'react';

const MongoDB_addFields = () => {
  return (
    <div>
      <h1>MongoDB_addFields Component</h1>
      <p>This is the MongoDB_addFields page.</p>
    </div>
  );
};

export default MongoDB_addFields;
